import React from "react";

const OrderListItem = ({ order = {} }) => {
  const services = order.services?.map((service) => service.service.title);

  return (
    <div className="order-list__item" key={order.id}>
      <div className="top">
        <div className="date">{order.from}</div>
        <div className={`status ${order.status?.value}`}>{order.status?.label}</div>
      </div>
      <div className="mid">
        <div className="photo">
          <img src={order.studio?.images?.[0]} alt="salon photo" />
        </div>
        <div className="info">
          <div className="studio-name">{order.studio?.title}</div>
          <div className="services">{services.join()}</div>
        </div>
      </div>
      <div className="bottom">
        <div className="cost-title">Total Payment</div>
        <div className="cost">{order.price} €</div>
      </div>
    </div>
  );
};

export default OrderListItem;
